// extracted by mini-css-extract-plugin
module.exports = {"contentBlock":"_10gBYq6MbGLCyskG5VRQIn","imgContainer":"_2neC0qqEcQOT8w0HrlZLVC","img":"fzy5TEt5G2YEyTEPRNxS2"};